export default __webpack_public_path__ + "static/media/SML2.48eedb30.jpeg";